import { Component, Input } from '@angular/core';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { SelfOnboardingDocument } from '@models/payroll/self-onboarding-document.model';

@Component({
    selector: 'app-document-status-badge[document]',
    template: `<ui-badge *ngIf="document.state !== 'new'" [type]="badgeType">{{ label | translate }}</ui-badge>`,
})
export class DocumentStatusBadgeComponent {
    @Input() document!: SelfOnboardingDocument;

    get badgeType(): BadgeType {
        switch (this.document.state) {
            case 'ready_for_review':
                return 'warning';
            case 'verified':
                return 'success';
            case 'rejected':
                return 'danger';
            default:
                return 'default';
        }
    }

    get label(): string {
        return `payroll.setup.selfOnboardingDocumentState.${this.document.state}`;
    }
}
